import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle } from "vue"

import { computed } from "vue";
import { IconDisplayProps } from "@/types";
import { getIcon } from "@/util";
import SafaIcon from "@/components/common/display/icon/SafaIcon.vue";


/**
 * Icon
 */
const __default__ = {
  name: "Icon",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    variant: {},
    id: {},
    size: {},
    rotate: {},
    color: {},
    style: {},
    dataCy: {}
  },
  setup(__props: any) {

const props = __props;

const iconId = computed(() => {
  if (props.id) {
    return props.id;
  }

  return getIcon(props.variant);
});

const iconColor = computed(() => {
  if (props.color?.includes("#")) {
    return "";
  } else if (props.color) {
    return props.color;
  }

  switch (props.variant) {
    case "home-list":
    case "home-add":
    case "trace-approve":
      return "primary";
    case "warning":
      return "secondary";
    case "error":
    case "trace-decline":
    case "trace-decline-all":
      return "negative";
    default:
      return "";
  }
});

const iconStyle = computed(() => {
  if (props.style) {
    return props.style;
  } else if (props.rotate) {
    return `transform: rotate(${props.rotate}deg)`;
  } else if (props.color?.includes("#")) {
    return `color: ${props.color}`;
  } else {
    return "";
  }
});

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!

  return (props.variant === 'safa')
    ? (_openBlock(), _createBlock(SafaIcon, {
        key: 0,
        "icon-only": ""
      }))
    : (_openBlock(), _createBlock(_component_q_icon, {
        key: 1,
        color: iconColor.value,
        size: props.size,
        style: _normalizeStyle(iconStyle.value),
        name: iconId.value,
        "data-cy": `icon-${props.variant}`
      }, null, 8, ["color", "size", "style", "name", "data-cy"]))
}
}

})